<template>
  <div class="business-hours-doorder-container">
    <business-hours-day
      v-for="(hours, day) in days"
      @hours-change="hoursChange"
      :key="day"
      :day="day"
      :hours="hours"
      :name="name"
      :time-increment="timeIncrement"
      :type="type"
      :color="color"
      :localization="localization"
      :switch-width="switchWidth"
      :hour-format24="hourFormat24"
    ></business-hours-day>
  </div>
</template>

<script>
import BusinessHoursDay from './BusinessHoursDayDoorder.vue';
export default {
  name: 'BusinessHours',
  components: {
    BusinessHoursDay
  },
  props: {
    days: {
      type: Object,
      required: true
    },
    name: {
      type: String,
      default: 'businessHours'
    },
    type: {
      type: String,
      default: 'datalist',
      validator: function(value) {
        return ['datalist', 'select'].indexOf(value) !== -1;
      }
    },
    timeIncrement: {
      type: Number,
      default: 30,
      validator: function(value) {
        return [15, 30, 60].indexOf(value) !== -1;
      }
    },
    color: {
      type: String,
      default: '#2779bd',
      validator: function(value) {
        return value.charAt(0) === '#' ? true : false;
      }
    },
    localization: {
      type: Object,
      default: () => ({
        switchOpen: 'Open',
        switchClosed: 'Closed',
        placeholderOpens: 'From',
        placeholderCloses: 'To',
        placeholderLocation:'Select location',
        addHours: 'Add hours',
        open: {
          invalidInput:
            'Please enter an from time in the 12 hour format (ie. 08:00 AM). You may also enter "24 hours".',
          greaterThanNext:
            'Please enter an from time that is before the to time.',
          lessThanPrevious:
            'Please enter an from time that is after the previous to time.',
          midnightNotLast:
            "Midnight can only be selected for the day's last to time."
        },
        close: {
          invalidInput:
            'Please enter a to time in the 12 hour format (ie. 05:00 PM). You may also enter "24 hours" or "Midnight".',
          greaterThanNext:
            'Please enter a to time that is after the from time.',
          lessThanPrevious:
            'Please enter a to time that is before the next from time.',
          midnightNotLast:
            "Midnight can only be selected for the day's last to time."
        },
        t24hours: '24 hours',
        midnight: 'Midnight',
        days: {
          monday: 'Monday',
          tuesday: 'Tuesday',
          wednesday: 'Wednesday',
          thursday: 'Thursday',
          friday: 'Friday',
          saturday: 'Saturday',
          sunday: 'Sunday',
          newYearsEve: 'New Year\'s Eve', // prettier-ignore
          newYearsDay: 'New Year\'s Day', // prettier-ignore
          martinLutherKingJrDay: 'Martin Luther King, Jr. Day',
          presidentsDay: 'Presidents\' Day', // prettier-ignore
          easter: 'Easter',
          memorialDay: 'Memorial Day',
          independenceDay: 'Independence Day',
          fourthOfJuly: '4th of July',
          laborDay: 'Labor Day',
          columbusDay: 'Columbus Day',
          veteransDay: 'Veterans Day',
          thanksgiving: 'Thanksgiving',
          christmasEve: 'Christmas Eve',
          christmas: 'Christmas'
        }
      })
    },
    switchWidth: {
      type: Number,
      default: 90
    },
    hourFormat24: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    hoursChange: function(val) {
      this.$emit('updated-hours', val);
    }
  }
};
</script>

<style scoped>
.business-hours-doorder-container {
  display: block;
  width: 100%;
  /* max-width: 630px; */
  font-size: 15px;
  color: #3d4852;
}
</style>



// WEBPACK FOOTER //
// src/components/vue-business-hours/BusinessHoursDoorder.vue